<!-- Carousel Start -->
<!-- <app-public-header></app-public-header>
<mdb-carousel [controls]="true" [indicators]="true" [animation]="'fade'" >
    <mdb-carousel-item style="z-index: -1;">
        <img src="../../../assets/img/image4_obrgm.jpeg" height="540px" class="d-block w-100" alt="..." />

    </mdb-carousel-item>

    <mdb-carousel-item style="z-index: -1;">
        <img src="../../../assets/img/img2.jpg" height="540px" class="d-block w-100" alt="..." />
    </mdb-carousel-item>
    <div class="carousel-caption-container mb-40 ">
        <div class="carousel-caption-content">
            <h1 class="text-white ">
                Office Béninois de Recherches Géologiques et Minières
            </h1>
            <p class="mb-5 fs-5 text-white">
                L’Office Béninois de Recherches Géologiques et Minières est chargé de gérer <br> et d’assurer les
                missions de
                service public dans les domaines de la géologie et des mines. <br> Il est le correspondant des
                organismes
                sous-régionaux, régionaux et internationaux de recherches géologiques et minières.
            </p>
            <div class="text-left">
                <a (click)="routerAbout()" id="but" class="btn btn-primary rounded-pill text-white py-3 px-5">
                    En savoir +
                </a>
            </div>
        </div>
    </div>
</mdb-carousel><br><br><br>

<section class="banner mb-4">
    <div class="banner-overlay"></div>
    <div class="container">
        <div class="row align-items-center banner-content">
            <div class="col-md-12 text-center text-center">
                <h2 style="color: white;">Dépôt National de Substances Explosives</h2>
                <p>Le Dépôt National de Substances Explosives à Djidja est un projet clé pour la sécurisation et la gestion des substances explosives utilisées dans l’extraction minière au Bénin. Il vise à renforcer la sécurité, optimiser la logistique et soutenir la valorisation locale des ressources minérales, tout en stimulant l’économie de la région...
                </p>
                <a style="background-color: white; color: black;" routerLink="/article" href="javascript:void(0);"
                    class="btn btn-custom">En savoir +</a>
            </div>

        </div>
    </div>
</section>


<section class="banner mb-4">
    <div class="banner-overlay"></div>
    <div class="container">
        <div class="row align-items-center banner-content">
            <div class="col-md-6 text-center text-md-start">
                <h2 style="color: white;">Qui
                    sommes-nous ?</h2>
                <p>Créé le 13 Août 1977 par décret N°77-29 sous la dénomination de l'Office ......</p>
                <a style="background-color: white; color: black;" href="javascript:void(0);" routerLink="/apropos"
                    class="btn btn-custom">En savoir +</a>
            </div>
            <div class="col-md-6 text-center text-md-start mt-4 mt-md-0">
                <h2 style="color: white;">Mission</h2>
                <p>L'Office Béninois de Recherches Géologiques et Minières est chargé de gérer......</p>
                <a style="background-color: white; color: black;" href="javascript:void(0);" routerLink="/mission"
                    class="btn btn-custom">En savoir +</a>
            </div>
        </div>
    </div>
</section>

<section class="banner">
    <div class="banner-overlay"></div>
    <div class="container">
        <div class="row align-items-center banner-content">
            <div class="col-md-6 text-center text-md-start">
                <h2 style="color: white;">Nos métiers </h2>
                <p>Explorez les métiers variés et passionnants au cœur de notre institution....</p>
                <a style="background-color: white; color: black;" routerLink="/metiers" href="javascript:void(0);"
                    class="btn btn-custom">En savoir +</a>
            </div>
            <div class="col-md-6 text-center text-md-start mt-4 mt-md-0">
                <h2 style="color: white; font-family: Montserrat;">Nos réalisations </h2>
                <p>Découvrez également les réalisations remarquables qui façonnent notre institution au quotidien</p>
                <a id="bordure" style="background-color: white; color: black;" routerLink="/realisations" href="javascript:void(0);"
                    class="btn btn-custom">En savoir +</a>
            </div>
        </div>
    </div>
</section>

<br><br> -->





<app-public-header></app-public-header>

<header
  id="carouselExample"
  class="carousel slide hero"
  data-bs-ride="carousel"
  data-bs-interval="3000"
  *ngIf="zoneSlideItems.length > 0"
>
  <div class="carousel-inner">

    <div
      *ngFor="let slide of zoneSlideItems; let i = index"
      class="carousel-item"
      [class.active]="i === 0"
    >

      <!-- Placeholder -->
      <div
        class="image-placeholder"
        *ngIf="!imagesLoaded[i]"
      ></div>

      <!-- Image réelle -->
      <img
        [src]="slide.image"
        class="d-block w-100 carousel-img"
        [class.loaded]="imagesLoaded[i]"
        (load)="onImageLoad(i)"
        (error)="onImageErrorSilde($event, i)"
        alt="slide image"
      />

      <div class="overlay"></div>

      <div class="hero-content" *ngIf="imagesLoaded[i]">
        <h1 class="text-white">{{ slide.titre }}</h1>
        <p>{{ slide.description }}</p>
      </div>

    </div>

  </div>

  <button class="carousel-control-prev" type="button" data-bs-target="#carouselExample" data-bs-slide="prev">
    <span class="carousel-control-prev-icon"></span>
  </button>

  <button class="carousel-control-next" type="button" data-bs-target="#carouselExample" data-bs-slide="next">
    <span class="carousel-control-next-icon"></span>
  </button>
</header>


<header *ngIf="zoneSlideItems.length === 0" id="carouselExample" class="carousel slide hero" data-bs-ride="carousel" data-bs-interval="1000">
    <div class="carousel-inner">
        <div class="carousel-item active" style="background-image: url('./../../../assets/images/mairi.png');">
            <div class="overlay"></div>
            <div class="hero-content">
                <h1 style="color: white;">Bienvenue sur x-project Votre solution professionnelle de suivi évaluation
                </h1>
                <p>Découvrez x-project, l’outil intuitif qui simplifie la gestion de vos programmes. Suivez et évaluez
                    vos performances en temps réel avec une solution adaptée à vos besoins.</p>
            </div>
        </div>
        <div class="carousel-item" style="background-image: url('./../../../assets/images/PalaisRoyalParakou.jpg');">
            <div class="overlay"></div>
            <div class="hero-content">
                <h1 style="color: white;">Suivez l’avancement de vos programmes en temps réel</h1>
                <p>Restez informé de l’évolution de vos programmes à chaque instant avec x-project. Visualisez les
                    progrès en temps réel pour une prise de décision rapide.</p>
            </div>
        </div>
        <div class="carousel-item" style="background-image: url('./../../../assets/images/pres.jpeg');">
            <div class="overlay"></div>
            <div class="hero-content">
                <h1 style="color: white;">Suivez l’avancement de vos programmes en temps réel</h1>
                <p>Restez informé de l’évolution de vos programmes à chaque instant avec x-project. Visualisez les
                    progrès en temps réel pour une prise de décision rapide.</p>
            </div>
        </div>
    </div>
    <button class="carousel-control-prev" type="button" data-bs-target="#carouselExample" data-bs-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    </button>
    <button class="carousel-control-next" type="button" data-bs-target="#carouselExample" data-bs-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
    </button>
</header>

<!-- Section : Mot du Maire -->
<section class="mot-du-maire container py-5">

    <div class="row align-items-center">

        <!-- SKELETON -->
        <ng-container *ngIf="loadingMotDumaire; else contentm">

            <!-- Col image -->
            <div class="col-md-6 text-center mb-4 mb-md-0">
                <p-skeleton shape="circle" width="220px" height="220px" styleClass="mx-auto"></p-skeleton>
            </div>

            <!-- Col texte -->
            <div class="col-md-6">
                <p-skeleton width="40%" height="1.5rem" class="mb-3"></p-skeleton>
                <p-skeleton width="60%" height="1.2rem" class="mb-2"></p-skeleton>
                <p-skeleton width="50%" height="0.9rem" class="mb-4"></p-skeleton>

                <p-skeleton width="100%" height="0.9rem"></p-skeleton>
                <p-skeleton width="95%" height="0.9rem"></p-skeleton>
                <p-skeleton width="90%" height="0.9rem"></p-skeleton>
                <p-skeleton width="85%" height="0.9rem"></p-skeleton>
            </div>

        </ng-container>

        <!-- CONTENU RÉEL -->
        <ng-template #contentm>
            <div class="col-md-6 text-center mb-4 mb-md-0">
                <img [src]="mayorImage" (error)="onImageError($event)" alt="Photo du Maire" class="maire-photo">
            </div>

            <div class="col-md-6">
                <h3 class="section-title mb-3">MOT DU MAIRE</h3>
                <p class="maire-message">
                    {{ mayorMessage || '-' }}
                </p>

                <div class=" d-flex justify-content-end">
                    <h5 class="maire-nom">{{ mayorName|| '-' }}</h5>
                </div>
            </div>
        </ng-template>

    </div>
</section>


<!-- <section class="container py-5 mb-4" data-wow-delay="0.2s">
      <div class="structures-container">
          <h3 class="section-title">STRUCTURES SOUS TUTELLE :</h3>
          <a href="#" class="view-all">Toutes les structures →</a>
      </div>
      <div class="row mt-4">
          <div class="col-md-4">
              <div class="card">
                  <img src="./../../../assets/new-accueil/img1.jpg" alt="Structure 1" class="card-img-top">
                  <div class="card-body">
                      <h5 class="card-title">Agence Régionale de Développement</h5>
                      <p class="card-text">L’Agence Régionale de Développement vous accompagne avec une solution robuste de suivi-évaluation. Améliorez vos performances régionales grâce à des outils adaptés et intuitifs.</p>
                      <a href="#" class="lire-plus">Lire plus →</a>
                  </div>
              </div>
          </div>
          <div class="col-md-4">
              <div class="card">
                  <img src="./../../../assets/new-accueil/img4.jpg " alt="Structure 2" class="card-img-top">
                  <div class="card-body">
                      <h5 class="card-title">Fonds de Soutien aux Entrepreneurs</h5>
                      <p class="card-text">Le Fonds de Soutien aux Entrepreneurs facilite le suivi et l’évaluation de vos programme avec des outils dédiés. Assurez la réussite de vos initiatives grâce à une gestion précise et simplifiée.</p>
                      <a href="#" class="lire-plus">Lire plus →</a>
                  </div>
              </div>
          </div>
          <div class="col-md-4">
              <div class="card">
                  <img src="./../../../assets/new-accueil/img5.jpg" alt="Structure 3" class="card-img-top">
                  <div class="card-body">
                      <h5 class="card-title">Centre d'Innovation et de Recherche</h5>
                      <p class="card-text">Le Centre d'Innovation et de Recherche est un espace dédié à la créativité, à l’exploration scientifique et au développement de solutions novatrices. Il rassemble experts, chercheurs et entrepreneurs autour de programme à fort impact technologique, économique et social.

                      </p>
                      <a href="#" class="lire-plus">Lire plus →</a>
                  </div>
              </div>
          </div>
      </div>
  </section> -->


<!-- Section avec fond sombre -->
<section class="bg-dark text-white " data-wow-delay="0.2s">
    <div class="container">
        <div class="section-header">
            <h2 style="color: white;">LES PROJETS D'INVESTISSEMENTS DE LA MAIRIE </h2>
            <!-- <p style="color: white;">FORMATIONS ET ACCOMPAGNEMENTS POUR BOOSTER VOS COMPÉTENCES</p> -->
            <!-- <a href="#" class="btn btn-outline-light custom-btn">Toutes les formations →</a> -->
        </div>
    </div>
</section>

<!-- Conteneur des cartes avec effet de débordement -->
<div class="container mt-4 mb-4">
    <div class="row g-4">

        <!-- SKELETON -->
        <ng-container *ngIf="loading; else content">
            <div class="col-md-4 h-100" *ngFor="let i of [1,2,3]">
                <div class="card custom-card">

                    <!-- Image -->
                    <p-skeleton width="700px" height="200px"></p-skeleton>

                    <div class="card-body d-flex flex-column">

                        <!-- Titre -->
                        <p-skeleton width="70%" height="1.2rem"></p-skeleton>

                        <!-- Description -->
                        <p-skeleton width="100%" height="0.9rem" class="mt-2"></p-skeleton>
                        <p-skeleton width="95%" height="0.9rem"></p-skeleton>
                        <p-skeleton width="90%" height="0.9rem"></p-skeleton>

                        <!-- Lien -->
                        <p-skeleton width="40%" height="0.9rem" class="mt-auto"></p-skeleton>

                    </div>
                </div>
            </div>

        </ng-container>

        <!-- CONTENU RÉEL -->
        <ng-template #content>
            <div class="col-md-4 h-100" *ngFor="let item of ArticlePdcItems.slice(0,3)">
                <div class="card custom-card">
                    <img [src]="item.photo" (error)="onImageError($event)" [alt]="item.title">

                    <div class="card-body d-flex flex-column">
                        <h1 class="card-title fs-3">
                            {{ item.titre_projet.slice(0,30) }}...
                        </h1>

                        <p class="card-text fs-5">
                            {{ item.description_projet.slice(0,60) }}...
                        </p>

                        <a (click)="goToDetailProjet(item)" style="cursor:pointer">
                            Lire plus →
                        </a>
                    </div>
                </div>
            </div>
        </ng-template>

    </div>
</div>


<app-public-footer></app-public-footer>